import React from "react";
import { PHOTO_DELETE } from "../../api";
import useFetch from "../../Hooks/useFetch";
import styles from "./PhotoDelete.module.css";

function PhotoDelete({ id }) {
	const { loading, request } = useFetch();

	async function handleClick(event) {
		const confirm = window.confirm("Tem certeza que deseja remover?");

		if (confirm) {
			const { url, options } = PHOTO_DELETE(id);
			const { response } = await request(url, options);
			if (response.ok) window.location.reload();
		}
	}

	return (
		<>
			{loading ? (
				<button className={styles.delete} onClick={handleClick} disabled>
					Remover
				</button>
			) : (
				<button className={styles.delete} onClick={handleClick}>
					Remover
				</button>
			)}
		</>
	);
}

export default PhotoDelete;
